import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "./AuthContext";
import { getLists } from "../api/instagram";
import { handleError } from "../services/error";

const defaultState = {
  lists: [],
}

export const ListsContext = createContext(defaultState);

export const ListsContextProvider = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const [lists, setLists] = useState([]);

  const fetchLists = useCallback(async (token) => {
    try {
      const response = await getLists();
      setLists(response);
    } catch (error) {
      handleError(error);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchLists();
    }
  }, [fetchLists, isLoggedIn]);

  const refreshLists = useCallback(async () => {
    await fetchLists();
  }, [fetchLists]);

  const contextValue = useMemo(
    () => ({
      lists,
      refreshLists
    }),
    [lists, refreshLists]
  )

  return <ListsContext.Provider value={contextValue}>{children}</ListsContext.Provider>;
}

export const useLists = () => {
  return useContext(ListsContext);
}